import { batch, useDispatch, useSelector } from 'react-redux';
import React, { useCallback } from 'react';

import {
  setNeedToRefetchSubData,
  setPaymentState,
  setUpgradeModalOpen,
} from '../../actions';

import styles from '../Components.module.css';
import usePaddleAccountDetails from '../../hooks/useQuery/usePaddleAccountDetails';
import usePlan from '../../hooks/usePlan';

import { IState, IUser } from '../../graphql/types';
import { CreditCardOutlined, UserOutlined } from '@ant-design/icons';
import { PaymentState } from '../../types';
import { UpgradeState } from './Plans';
import { Button, Flex, Skeleton } from 'antd';

export function PaddleUpgrade({ selectedPlan, setUpgradeState }) {
  const dispatch = useDispatch();
  const { updatePlan } = usePlan();
  const user = useSelector<IState, IUser | undefined>(state => state.user);

  const { data: accountDetailsData } = usePaddleAccountDetails(
    user!.plan!.subscriptionIDs![user!.plan!.subscriptionIDs!.length - 1]
  );

  const handleConfirm = useCallback(async () => {
    batch(() => {
      dispatch(setPaymentState(PaymentState.processing));
      dispatch(setNeedToRefetchSubData(true));
      dispatch(setUpgradeModalOpen(false));
    });

    await updatePlan(+selectedPlan.planId!);
  }, [dispatch, selectedPlan.planId, updatePlan]);

  const handleGoBack = () => {
    setUpgradeState(UpgradeState.default);
  };

  const userCardIdentifier = `${
    accountDetailsData?.cardType || 'Card'
  } ending in ${accountDetailsData?.lastFourDigits}`;

  const userEmail = accountDetailsData?.email || '';

  return (
    <div className={styles.giideDetailedPlans} style={{ width: 'fit-content' }}>
      <div className={styles.upgradeConfirmation}>
        <h2>
          Upgrade to <span>{selectedPlan.title}</span>
        </h2>
        <Skeleton loading={!accountDetailsData} active>
          {accountDetailsData && (
            <div>
              <Flex gap={'small'}>
                {' '}
                <UserOutlined />
                <div>{userEmail}</div>
              </Flex>

              <Flex gap="small">
                <CreditCardOutlined />
                <div>{userCardIdentifier}</div>
              </Flex>

              <Flex
                gap={'middle'}
                justify={'flex-end'}
                style={{ marginTop: '24px' }}
              >
                <Button onClick={handleGoBack}>Go back</Button>
                <Button type={'primary'} onClick={handleConfirm}>
                  Upgrade now
                </Button>
              </Flex>
            </div>
          )}
        </Skeleton>
      </div>
    </div>
  );
}
